export default "__VITE_ASSET__IY6NasCR__"